window.Finch = {
	navigate: function (uri, queryParams, doUpdate) {
		Grape.router.navigate(uri, null, queryParams, doUpdate);
	}
};
